<template>
  <DashboardTemplate class="course-learn">
    <el-row v-loading="loading">
      <el-col :span="24" :md="16">
        <div class="flex-display js-between ai-center mg-b-2 column-mobile">
          <h3 class="mg-y-less text-left">หลักสูตร {{ courseName }}</h3>
          <SocialShare
            :courseName="courseName"
            :message="`หลักสูตร ${courseName}`"
            :urlCopy="`course/detail?courseId=${courseId}`"
          />
        </div>

        <div v-if="topic || subjecFile" class="border-b">
          <div
            v-loading="
              showVideo == true || showSubjectFile == true ? false : true
            "
            class="video-box"
          >
            <VideoPlay
              v-if="showVideo && topic.attach"
              :id="courseId"
              :topic="getTopicVideo()"
              :video="topic.attach.file"
              :image="courseImage"
              :takes="takes"
              @saveTrackVideo="saveTrackVideo"
              @setAllTimeVideo="setAllTimeVideo"
            />
            <VideoPlay
              v-if="showSubjectFile && topic.attach"
              :id="courseId"
              :video="subjecFile.file"
            />
          </div>

          <p v-if="showVideo" class="text-font-14">
            <span class="text-weight-bold">หัวข้อที่ {{ topic.index }}</span>
            {{ topic.topic }}
          </p>

          <p v-if="showSubjectFile" class="text-font-14">
            {{ subjecFile.default }}
          </p>
        </div>

        <div
          v-else
          class="image-not-video mg-b-2"
          :style="`background-image:url(` + urlImage + `);`"
        ></div>

        <div v-if="showVideo && topic" class="text-left">
          <h4 class="mg-b-4 text-font-16">
            เนื้อหาหัวข้อที่ {{ topic.index }}
            {{ topic.topic }}
          </h4>

          <div
            class="message-topic-box text-font-16"
            :class="{ 'show-all': showAllTopic }"
          >
            <viewer v-if="topic.detail" :initialValue="topic.detail" />
          </div>
          <p
            v-if="topic.detail"
            @click="showAllTopic = !showAllTopic"
            class="cursor-pointer color-secondary text-font-14"
          >
            {{ showAllTopic ? "ย่อ" : "อ่านรายละเอียด" }}
          </p>
        </div>
      </el-col>
      <el-col
        v-if="courseSubjects.length > 0"
        :span="24"
        :md="8"
        class="text-left"
      >
        <div class="pd-l-3">
          <CourseLearnList
            :courseId="courseId"
            :subjectsList="courseSubjects"
            :courseName="courseName"
            :takes="takes"
            :collapse="collapse"
            :countPostTest="countPostTest"
            :roundPostTest="roundPostTest"
            :assessment="assessment"
            :subjectSuccess="subjectSuccess"
            :taksAssessment="taksAssessment"
            :statusCourse="statusCourse"
            @setTopic="setTopic"
            @setSubjectFile="setSubjectFile"
          />
        </div>
      </el-col>
    </el-row>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import CourseLearnList from "@/components/course/CourseLearnList";
import SocialShare from "@/components/social/SocialShare";
import VideoPlay from "@/components/social/VideoPlay";
import { HTTP } from "@/service/axios.js";
import { Viewer } from "@toast-ui/vue-editor";

export default {
  components: {
    DashboardTemplate,
    CourseLearnList,
    SocialShare,
    VideoPlay,
    viewer: Viewer,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    urlImage() {
      if (this.image != "") {
        return `${this.urlCouse}${this.courseId}/${this.courseImage}`;
      } else {
        return "https://1080motion.com/wp-content/uploads/2018/06/NoImageFound.jpg.png";
      }
    },
  },
  data() {
    return {
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      courseId: "",
      courseName: "",
      courseImage: "",
      courseSubjects: [],
      subjectSuccess: false,
      topic: "",
      subjecFile: "",
      showVideo: true,
      showSubjectFile: false,
      takes: [],
      subjectId: "",
      allTimeVideo: 0,
      loading: false,
      collapse: [],
      topicId: "",
      countPostTest: 0,
      roundPostTest: [],
      assessment: [],
      showAllTopic: false,
      taksAssessment: false,
      statusCourse: 0,
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchRoundPostTest();
    this.fetchTakes();
    this.saveLogLearn();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
          this.subjectId = this.routeParams.subjectId;
        }
      }
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
    },
    saveLogLearn() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`learn/course/${this.courseId}`).then((res) => {});
    },
    fetchRoundPostTest() {
      let obj = {
        courseId: this.courseId,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`round/post/test`, obj).then((res) => {
        if (res.data.success) {
          this.roundPostTest = res.data.obj;
        }
      });
    },
    fetchDetailCourse() {
      let obj = {
        _id: this.courseId,
      };

      HTTP.post(`detail/course`, obj)
        .then((res) => {
          if (res.data.success) {
            this.courseName = res.data.obj.name;
            this.courseSubjects = res.data.obj.subjects.sort((a, b) => {
              if (a.index > b.index) return 1;
              if (a.index < b.index) return -1;
              return 0;
            });
            this.courseImage = res.data.obj.illustration.file;
            this.countPostTest = res.data.obj.countPostTest;
            this.statusCourse = res.data.obj.statusCourse;
            this.assessment = res.data.obj.assessment;
            this.subjectSuccess =
              res.data.obj.subjects.length == res.data.obj.subjectNumber;

            let index = this.courseSubjects.findIndex(
              (find) => this.subjectId == find.subjectId
            );

            if (index > -1) {
              this.collapse.push(index);
            }

            let filter = this.courseSubjects.filter(
              (filter) => this.subjectId == filter.subjectId
            );

            if (filter.length > 0) {
              let topicFilter = filter[0].topics.filter(
                (filter) => this.topicId == filter._id
              );

              if (topicFilter.length > 0) {
                this.topic = topicFilter[0];
              } else {
                this.topic = "";
              }
            }
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchDetailCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    setTopic(data, subjectId) {
      this.$store.commit("SET_TOPIC_LATEST", data._id);
      this.$router
        .push(
          `/course/learn?courseId=${this.courseId}&subjectId=${subjectId}&topicId=${data._id}`
        )
        .catch((e) => {
          window.location.reload();
        });
    },
    nextTopic(id) {
      let filter = this.courseSubjects.filter(
        (filter) => filter.subjectId == this.subjectId
      );

      if (filter.length > 0) {
        let index = filter[0].topics.findIndex(
          (index) => index._id == this.topic._id
        );

        if (typeof filter[0].topics[index + 1] != "undefined") {
          this.setTopic(filter[0].topics[index + 1], this.subjectId);
        } else if (typeof this.courseSubjects[0].topics[0] != "undefined") {
          this.setTopic(this.courseSubjects[0].topics[0], this.subjectId);
        } else {
          let index = this.courseSubjects.findIndex(
            (index) => index.subjectId == this.subjectId
          );
          let subjecId =
            typeof this.courseSubjects[index + 1] != "undefined"
              ? this.courseSubjects[index + 1].subjectId
              : this.courseSubjects[0].subjectId;
          this.$router
            .push(
              `/course/learn?courseId=${this.courseId}&subjectId=${subjecId}`
            )
            .catch((e) => {
              window.location.reload();
            });
        }
      }
    },
    setSubjectFile(data, subjectId) {
      this.showSubjectFile = false;
      this.showVideo = false;
      this.subjecFile = data;
      this.subjectId = subjectId;
      setTimeout(() => {
        this.showSubjectFile = true;
      }, 500);
    },
    fetchTakes() {
      this.loading = true;
      this.showVideo = false;
      let obj = {
        courseId: this.courseId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/takes`, obj)
        .then((res) => {
          if (res.data.success) {
            this.takes = res.data.obj.subjects;
            this.taksAssessment =
              res.data.obj.assessment.length > 0 &&
              res.data.obj.assessment[0].assessment &&
              res.data.obj.assessment[0].assessment.length > 0
                ? true
                : false;

            let subject = res.data.obj.subjects.filter(
              (filter) => filter.subjectId == this.subjectId
            );
            if (subject.length > 0) {
              if (
                (typeof this.routeParams.topicId != "undefined" &&
                  subject[0].preTest.length > 0) ||
                this.user.role > 0
              ) {
                this.topicId = this.routeParams.topicId;
              } else {
                this.topicId = "";
              }
            }
          }
          this.fetchDetailCourse();
        })
        .finally(() => {
          this.showVideo = true;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    getTopicVideo() {
      let video = [];
      let topic = [];
      let subject = this.takes.filter(
        (filter) => filter.subjectId == this.subjectId
      );
      if (subject.length > 0) {
        topic = subject[0].topic.filter(
          (filter) => filter.actionTo == this.topic._id
        );
      }

      if (topic.length > 0) {
        video = [];
        video = topic.sort((a, b) => {
          if (
            new Date(a["updatedAt"]).getTime() >
            new Date(b["updatedAt"]).getTime()
          ) {
            return -1;
          }
          return 0;
        });
      }

      return video.length > 0 ? video[0] : null;
    },
    saveTrackVideo(nextTo, watched, timeAll, latestTime) {
      if (
        this.topic.durationTime &&
        new Date().setHours(0, 0, 0, 0) >=
          new Date(this.topic.durationTime.open).getTime() &&
        new Date().setHours(0, 0, 0, 0) <=
          new Date(this.topic.durationTime.close).getTime()
      ) {
        let obj = {
          type: "topic",
          actionTo: this.topic._id,
          courseId: this.courseId,
          subjectId: this.subjectId,
          suggestion: "",
          latestTime: latestTime,
          watched: watched,
          percent: this.getPercentGrowth(timeAll),
        };

        if (nextTo && this.getPercentGrowth(timeAll) >= 70) {
          this.nextTopic(this.courseId);
        }
        if (this.user.role == 0) {
          HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
          HTTP.post(`take`, obj).then((res) => {});
        }
      }
    },
    getPercentGrowth(num) {
      let ratePercent = this.allTimeVideo / 100;
      let percent = num / ratePercent;
      if (isFinite(percent) === true) {
        return Number(percent.toFixed(2));
      } else {
        return 0;
      }
    },
    setAllTimeVideo(time) {
      this.allTimeVideo = time;
    },
  },
};
</script>

<style scoped>
.image-not-video {
  height: 550px;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  border-radius: 10px;
}
.message-topic-box {
  overflow: hidden;
  max-height: 230px;
}
.message-topic-box.show-all {
  max-height: unset;
}
@media (max-width: 575.98px) {
  .message-topic-box {
    overflow: hidden;
    max-height: 220px;
  }
  .image-not-video {
    height: 270px;
  }
}
</style>
